import { S3_BUCKET_URL, GIRLS_CATEGORY } from '@/constants';

import { ScreenBiggestTurnOn } from './screens/BiggestTurnOn';
import { ScreenEmail } from './screens/Email';
import { ScreenHerPartDrivesCrazy } from './screens/HerPartDrivesCrazy';
import { ScreenIdealDate } from './screens/IdealDate';
import { ScreenIdealMatchArchetypes } from './screens/IdealMatchArchetypes';
import { ScreenMostIntimateMoment } from './screens/MostIntimateMoment';
import { NameScreen } from './screens/Name';
import { ScreenPartyBehavior } from './screens/PartyBehavior';
import { ScreenProgress } from './screens/Progress';
import { ScreenProgress90 } from './screens/Progress/Progress90';
import { ScreenRelationshipRole } from './screens/RelationshipRole';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { WelcomeScreen } from './screens/Welcome';
import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  party_behavior: {
    component: ScreenPartyBehavior,
    images: [
      `${S3_BUCKET_URL}/own-ai-compatibility/party-behavior/find_one_person.png`,
      `${S3_BUCKET_URL}/own-ai-compatibility/party-behavior/mingle_with_everyone.png`,
      `${S3_BUCKET_URL}/own-ai-compatibility/party-behavior/stay_with_friends.png`,
      `${S3_BUCKET_URL}/own-ai-compatibility/party-behavior/observe_from_corner.png`,
    ],
  },
  ideal_date: {
    component: ScreenIdealDate,
    images: [],
  },
  biggest_turn_on: {
    component: ScreenBiggestTurnOn,
    images: [],
  },
  progress_40: {
    component: ScreenProgress,
    images: [`${S3_BUCKET_URL}/own-ai-compatibility/progress/progress-40.png`],
  },
  most_intimate_moment: {
    component: ScreenMostIntimateMoment,
    images: [],
  },
  relationship_role: {
    component: ScreenRelationshipRole,
    images: [],
  },
  progress_90: {
    component: ScreenProgress90,
    images: [`${S3_BUCKET_URL}/own-ai-compatibility/progress/progress-90.png`],
  },
  her_part_drives_crazy: {
    component: ScreenHerPartDrivesCrazy,
    images: [],
  },
  name: {
    component: NameScreen,
    images: [`${S3_BUCKET_URL}/own-ai-compatibility/name/background.png`],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  ideal_match_archetypes: {
    component: ScreenIdealMatchArchetypes,
    images: [`${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  name: '',
  email: '',
  ideal_date: null,
  biggest_turn_on: null,
  most_intimate_moment: null,
  party_behavior: null,
  relationship_role: null,
  her_part_drives_crazy: null,
};

// GIRLS CATEGORIES
export const HARDCODED_CATEGORIES = [GIRLS_CATEGORY];
